<script>
import { isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { commitHistory } from "@app/store/historyStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import * as m from "@app/paraglide/messages.js";

/** @type {{ row: any, column: any, api?: any }} */
let { row } = $props();

let isCustom = $derived(typeof row?.xPos === "number");
let current = $derived(normalizeXPos(row?.xPos));

/**
 * @param {string | number | undefined | null} value
 */
function normalizeXPos(value) {
    if (value === "start" || value === "left") return "start";
    if (value === "end" || value === "right") return "end";
    return "center";
}

/**
 * @param {"start" | "center" | "end"} xPos
 */
function setXPos(xPos) {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }

    const egIdx = projectState.selected;
    const eventId = row?.id;
    if (eventId == null || egIdx == null) return;

    commitHistory({
        name: "update horizontal position",
        eventGroup: egIdx,
        mutate: {
            eventGroupState: (draft) => {
                const idx = draft[egIdx].events.findIndex((e) => e.id === eventId);
                if (idx < 0) return;
                draft[egIdx].events[idx].xPos = xPos;
                if (!draft[egIdx].selected.includes(idx)) {
                    draft[egIdx].selected = [idx];
                }
            },
        },
    });
}
</script>

{#if isCustom}
    <span class="custom-pos" title={String(row.xPos)}>{row.xPos}</span>
{:else}
    <div class="lcr-cell" role="group" aria-label={m.editor_table_column_h()}>
        <button
            type="button"
            class="lcr-btn"
            class:active={current === "start"}
            title="Left"
            onclick={(e) => {
                e.stopPropagation();
                setXPos("start");
            }}>L</button>
        <button
            type="button"
            class="lcr-btn"
            class:active={current === "center"}
            title="Center"
            onclick={(e) => {
                e.stopPropagation();
                setXPos("center");
            }}>C</button>
        <button
            type="button"
            class="lcr-btn"
            class:active={current === "end"}
            title="Right"
            onclick={(e) => {
                e.stopPropagation();
                setXPos("end");
            }}>R</button>
    </div>
{/if}

<style>
.custom-pos {
    user-select: text;
    font-size: 0.75rem;
}
.lcr-cell {
    display: inline-flex;
    gap: 2px;
    align-items: center;
    height: 100%;
}
.lcr-btn {
    border: 1px solid transparent;
    background: transparent;
    color: inherit;
    font-size: 0.7rem;
    font-weight: 600;
    line-height: 1;
    padding: 0.15rem 0.35rem;
    border-radius: 0.25rem;
    cursor: pointer;
    min-width: 1.4rem;
}
.lcr-btn:hover {
    background: rgba(13, 110, 253, 0.15);
}
.lcr-btn.active {
    background: #0d6efd;
    color: #fff;
}
</style>
